import { Button, Card, Col, Form, Input, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import style from './LadingPage.module.scss';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { AppState } from '../store';
import { removeloginCookie } from '../services/auth';
import ErrorMessage from '../globals/Components/Error/ErrorMessage';
import { getValidateToken, putUpdatePasswordUser } from '../store/user/thunks';

interface RegisterProps {
    errorMessage?: any;
    putUpdatePasswordUser?: any;
    getValidateToken?: any;
}

const UpdatePassword: React.FC<RegisterProps> = (props: RegisterProps) => {
    const [form] = Form.useForm();
    const history = useHistory();

      const [user, setUser] = useState("");
      const [organization, setOrganization] = useState("");
    interface RouteParams {
        token: string;
    }

    const params = useParams<RouteParams>();

    const init = async () => {
        if (props.getValidateToken) {
            const response = await props.getValidateToken(params.token);
            if (response.status == "SUCCESS") {
               setUser(response.id);
               setOrganization(response.organizationId);
            }
        }
    };

    useEffect(() => {
        init();
    }, []);

    removeloginCookie();

    const messageResponse = props.errorMessage?.message ? (
        <ErrorMessage>
            {props.errorMessage.message.map((item: string | null | undefined, index: number) => (
                <p key={index}>{item}</p>
            ))}
        </ErrorMessage>
    ) : null;

    const onFinish = async (values: any) => {
        const updatePassword = {
            id: user,
            organizationId: organization,
            password: values.repeatpassword
        }
        const response = await props.putUpdatePasswordUser(updatePassword);
        if (response.status == "SUCCESS") {
            history.push("/");
        }
    };

    const goStepValidateRegister = () => {
        history.push('/');
    };

    return (
        <div className={style.containerLogin}>
            <Row justify="center" align="middle" style={{ minHeight: '100vh' }}>
                <Col xs={22} sm={18} md={12} lg={8}>
                    <Card
                        style={{
                            borderRadius: 16,
                            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                        }}
                    >
                        <div style={{ textAlign: 'center', marginBottom: 24 }}>
                            <img
                                src={process.env.REACT_APP_URL_LOGO}
                                alt="TBC"
                                style={{ maxWidth: 180, marginBottom: 16 }}
                            />
                            <h2 style={{ marginBottom: 8 }}>Actualizar contraseña</h2>
                            <p style={{ color: '#666' }}>
                                Ingresa tu nueva contraseña y confírmala.
                            </p>
                        </div>

                        {messageResponse}

                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onFinish}
                            autoComplete="off"
                        >
                            <Form.Item
                                label="Nueva contraseña"
                                name="password"
                                rules={[
                                    { required: true, message: 'Por favor ingresa la contraseña' },
                                    { min: 6, message: 'La contraseña debe tener al menos 6 caracteres' },
                                ]}
                                hasFeedback
                            >
                                <Input.Password placeholder="Ingresa tu nueva contraseña" />
                            </Form.Item>

                            <Form.Item
                                label="Repetir contraseña"
                                name="repeatpassword"
                                dependencies={['password']}
                                hasFeedback
                                rules={[
                                    { required: true, message: 'Por favor repite la contraseña' },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('password') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(
                                                new Error('Las contraseñas no coinciden')
                                            );
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password placeholder="Repite tu nueva contraseña" />
                            </Form.Item>

                            <Row gutter={12}>
                                <Col span={12}>
                                    <Button block onClick={goStepValidateRegister}>
                                        Cancelar
                                    </Button>
                                </Col>
                                <Col span={12}>
                                    <Button type="primary" htmlType="submit" block>
                                        Guardar
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

const mapStateToProps = (state: AppState) => ({
    errorMessage: state.system.messageResponse,
});

export default connect(mapStateToProps, {
    getValidateToken, putUpdatePasswordUser
})(UpdatePassword);